import { render, staticRenderFns } from "./ShopSale.vue?vue&type=template&id=6b6414ea&scoped=true&"
import script from "./ShopSale.vue?vue&type=script&lang=js&"
export * from "./ShopSale.vue?vue&type=script&lang=js&"
import style0 from "./ShopSale.vue?vue&type=style&index=0&id=6b6414ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6414ea",
  null
  
)

export default component.exports